import {FETCH_SEO} from './types';
import {salomapi3} from '../apis';

export const fetchSeo =  (page,type) => async dispatch => {
    const response = await salomapi3.get('/seo?slug='+page+'&type='+type);
    dispatch({type:FETCH_SEO,payload:{seoData:response.data,page}})
}